export default __webpack_public_path__ + "static/media/my-volunteer-mockup-2.86a79907.png";